module.exports = __webpack_public_path__ + "img/pl-pl.94d610f2.svg";